/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AmountDecimalValidationError = {
  currency?: string | undefined;
  valueDecimal?: string | undefined;
};

/** @internal */
export const AmountDecimalValidationError$inboundSchema: z.ZodType<
  AmountDecimalValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  currency: z.string().optional(),
  valueDecimal: z.string().optional(),
});
/** @internal */
export type AmountDecimalValidationError$Outbound = {
  currency?: string | undefined;
  valueDecimal?: string | undefined;
};

/** @internal */
export const AmountDecimalValidationError$outboundSchema: z.ZodType<
  AmountDecimalValidationError$Outbound,
  z.ZodTypeDef,
  AmountDecimalValidationError
> = z.object({
  currency: z.string().optional(),
  valueDecimal: z.string().optional(),
});

export function amountDecimalValidationErrorToJSON(
  amountDecimalValidationError: AmountDecimalValidationError,
): string {
  return JSON.stringify(
    AmountDecimalValidationError$outboundSchema.parse(
      amountDecimalValidationError,
    ),
  );
}
export function amountDecimalValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<AmountDecimalValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AmountDecimalValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AmountDecimalValidationError' from JSON`,
  );
}
